<div #minMaxArea class="min-max" *ngIf="esriLayer">

    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Start Showing At Map Level: </label>
        <select class="pull-right" [(ngModel)]="esriLayer.minScale">
            <option *ngFor="let level of startScaleIntervals" [title]="level.value" [disabled]="level.value!==0 && level.value < esriLayer.maxScale" [ngValue]="level.value">
                {{ level.label }}
            </option>
        </select>
    </div>
    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Stop Showing At Map Level: </label>
        <select class="pull-right" [(ngModel)]="esriLayer.maxScale">
            <option *ngFor="let level of stopScaleIntervals" [title]="level.value" [disabled]="esriLayer.minScale!==0 && level.value > esriLayer.minScale" [ngValue]="level.value">
                {{ level.label }}
            </option>
        </select>
    </div>
    <div class="button-container">
        <button class="btn apply" (click)="reset()">Reset to Defaults</button>
        <button class="btn btn-clear cancel" (click)="close()">Close</button>
    </div>
</div>

